import { takeEvery, put, call } from "redux-saga/effects";
// import * as types from "./actionTypes";
import * as types from './actionTypes';
import {
  fetchEmployeeSalaryDefinition,
  fetchEmployeeSalaryDefinitionSuccess,
  fetchEmployeeSalaryDefinitionFailure,
  fetchEmployeeSalaryDefinitionClear,
  saveEmployeeSalaryDefinitionSuccess,
  saveEmployeeSalaryDefinitionFailure,
  fetchEmployeeSalaryIncrementSuccess,
  fetchEmployeeSalaryIncrementFailure,
  fetchEmployeeSalaryIncrementSavedCTCSuccess,
  fetchEmployeeSalaryIncrementSavedCTCFailure,
} from "./actions";
import { get, post, update, del } from "../../../../helpers/api_helper";
import { useHistory } from "react-router-dom";
import Swal from "sweetalert2";
import { showToast, showConfirm } from "../../../../common/Toaster";


// Fetch Employee Salary Definition
function* fetchEmployeeSalaryDefinitionSaga({ payload }) {
  try {
    const response = yield call(post, process.env.REACT_APP_PAYROLL_SALARY_FETCH_EMPLOYEE_SALARY_DEFINITION, payload);
    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to retrieve module!");
    }
    yield put(fetchEmployeeSalaryDefinitionSuccess(response));
  } catch (error) {
    console.error("Saga API Error:", error);
    yield put(fetchEmployeeSalaryDefinitionFailure(error.message));
  }
}

function* fetchEmployeeSalaryDefinitionClearSaga(action) {
  fetchEmployeeSalaryDefinitionClear();
}

// Save Employee Salary Definition Saga
function* saveEmployeeSalaryDefinitionSaga({ payload }) {
  try {
    const { formData, isEdit } = payload;
    const response = yield call(post, process.env.REACT_APP_PAYROLL_SALARY_SAVE_EMPLOYEE_SALARY_DEFINITION, formData);

    if (response?.status === "success") {
      Swal.fire({
        icon: "success",
        title: "Success",
        text: response.message || "Employee Salary Definition saved successfully!",
      });
      yield put(saveEmployeeSalaryDefinitionSuccess(response));
      const unitId = formData.get("unit_id");
      if (unitId) {
        yield put(fetchEmployeeSalaryDefinition(unitId));
      } else {
        console.log("unit_id is missing in formData, fetch not triggered");
      }
    } else {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: response.message || "Something went wrong!",
      });
      yield put(saveEmployeeSalaryDefinitionFailure("Unexpected response format"));
    }
  } catch (error) {
    console.error("Saga API Error:", error);
    Swal.fire({
      icon: "error",
      title: "API Error",
      text: error.message || "An error occurred while saving the deduction",
    });
    yield put(saveEmployeeSalaryDefinitionFailure(error.message));
  }
}

function* fetchEmployeeSalaryIncrementSaga({ payload }) {
  try {
    const response = yield call(post, process.env.REACT_APP_FETCH_EMPLOYEE_INCREMENT_CTC, payload);
    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to retrieve module!");
    }
    yield put(fetchEmployeeSalaryIncrementSuccess(response));
  } catch (error) {
    console.error("Saga API Error:", error);
    yield put(fetchEmployeeSalaryIncrementFailure(error.message));
  }
}

function* fetchfinancialtypesSaga({ payload }) {
  try {
    const response = yield call(post, process.env.REACT_APP_FETCH_FINANCIAL_TYPES, payload);
    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to retrieve module!");
    }
    yield put({ type: types.FETCH_FINANCIAL_INCREMENT_TYPES_SUCCESS, payload: response });
  } catch (error) {
    console.error("Saga API Error:", error);
    yield put({ type: types.FETCH_FINANCIAL_INCREMENT_TYPES_FAILURE, payload: response });
  }
}

function* fetchloantypesSaga({ payload }) {
  try {
    const response = yield call(post, process.env.REACT_APP_FETCH_LOAN_TYPES, payload);
    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to retrieve module!");
    }
    yield put({ type: types.FETCH_LOAN_TYPES_SUCCESS, payload: response });
  } catch (error) {
    console.error("Saga API Error:", error);
    yield put({ type: types.FETCH_LOAN_TYPES_FAILURE, payload: response });
  }
}

function* fetchloannumberSaga({ payload }) {
  try {
    const response = yield call(post, process.env.REACT_APP_FETCH_LOAN_NUMBER, payload);
    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to retrieve module!");
    }
    yield put({ type: types.FETCH_LOAN_LOANNUMBER_SUCCESS, payload: response });
  } catch (error) {
    console.error("Saga API Error:", error);
    yield put({ type: types.FETCH_LOAN_LOANNUMBER_FAILURE, payload: response });
  }
}

function* fetchloaninstallmentsSaga({ payload }) {
  try {
    const response = yield call(post, process.env.REACT_APP_FETCH_LOAN_MONTHLY_INSTALLMENTS, payload);
    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to retrieve module!");
    }
    yield put({ type: types.FETCH_LOAN_MONTHLY_INSTALLMENTS_SUCCESS, payload: response });
  } catch (error) {
    console.error("Saga API Error:", error);
    yield put({ type: types.FETCH_LOAN_MONTHLY_INSTALLMENTS_FAILURE, payload: response });
  }
}

function* saveloaninstallmentsSaga({ payload }) {
  try {
    const { formData, iclssEdit } = payload;
    const response = yield call(post, process.env.REACT_APP_SAVE_EMPLOYEE_LOAN_INSTALLMENTS, formData);

    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to Save Employee Loan!");
    }

    Swal.fire({ icon: response?.status, title: response?.status, text: response.message || "Employee Salary Loan saved successfully!", });
    yield put({ type: types.SAVE_LOAN_MONTHLY_INSTALLMENTS_SUCCESS, payload: response });
  } catch (error) {
    console.error("Saga API Error:", error);
    Swal.fire({ icon: "error", title: "API Error", text: error.message || "An error occurred while saving the deduction", });
    yield put({ type: types.SAVE_LOAN_MONTHLY_INSTALLMENTS_FAILURE, payload: response });
  }
}

function* fetchEmployeeLoanlistsSaga({ payload }) {
  try {
    const formData = new FormData();
    formData.append("unit_id", payload.formData || 0);
    formData.append("emp_code", 0);
    formData.append("type_id", 0);

    const response = yield call(post, process.env.REACT_APP_FETCH_EMPLOYEE_LOAN_LISTS, formData);
    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to retrieve module!");
    }
    yield put({ type: types.FETCH_EMPLOYEE_LOAN_LISTS_SUCCESS, payload: response });
  } catch (error) {
    console.error("Saga API Error:", error);
    yield put({ type: types.FETCH_EMPLOYEE_LOAN_LISTS_FAILURE, payload: response });
  }
}

function* fetchEmployeeLoaninstallmentsSaga({ payload }) {
  try {
    const response = yield call(post, process.env.REACT_APP_FETCH_EMPLOYEE_LOAN_INSTALLMENTS_LISTS, payload);
    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to retrieve module!");
    }
    yield put({ type: types.FETCH_EMPLOYEE_LOAN_INSTALLMENTS_SUCCESS, payload: response });
  } catch (error) {
    console.error("Saga API Error:", error);
    yield put({ type: types.FETCH_EMPLOYEE_LOAN_INSTALLMENTS_FAILURE, payload: error.message });
  }
}

function* saveEmployeeSalaryIncrementCTCSaga({ payload }) {
  try {
    const { formData, iclssEdit } = payload;
    const response = yield call(post, process.env.REACT_APP_SAVE_EMPLOYEE_INCREMENT_CTC, formData);

    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to Save Employee Increment CTC!");
    }

    Swal.fire({ icon: response?.status, title: response?.status, text: response.message || "Employee Salary Increment CTC saved successfully!", });
    yield put({ type: types.SAVE_EMPLOYEE_SALARY_INCREMENT_CTC_SUCCESS, payload: response });
  } catch (error) {
    console.error("Saga API Error:", error);
    Swal.fire({ icon: "error", title: "API Error", text: error.message || "An error occurred while saving the deduction", });
    yield put({ type: types.SAVE_EMPLOYEE_SALARY_INCREMENT_CTC_FAILURE, payload: error.message });
  }
}

// Fetch Employee Salary Increment Saved CTC Saga
function* fetchEmployeeSalaryIncrementsavedctcSaga({ payload }) {
  try {
    const response = yield call(post, process.env.REACT_APP_FETCH_EMPLOYEE_INCREMENT_SAVED_CTC, payload);
    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to retrieve module!");
    }
    yield put(fetchEmployeeSalaryIncrementSavedCTCSuccess(response.data));
  } catch (error) {
    console.error("Saga API Error:", error);
    yield put(fetchEmployeeSalaryIncrementSavedCTCFailure(error.message));
  }
}

function* fetchEmployeeIncrementapprovalctcSaga({ payload }) {
  try {
    const response = yield call(post, process.env.REACT_APP_FETCH_EMPLOYEE_INCREMENT_APPROVAL_CTC, payload);
    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to retrieve module!");
    }
    yield put({ type: types.FETCH_EMPLOYEE_INCREMENT_APPROVAL_CTC_SUCCESS, payload: response.data });
  } catch (error) {
    console.error("Saga API Error:", error);
    yield put({ type: types.FETCH_EMPLOYEE_INCREMENT_APPROVAL_CTC_FAILURE, payload: error.message });
  }
}

function* saveEmployeeIncrementApprovalCTCSaga({ payload }) {
  try {
    const { formData } = payload;
    const response = yield call(post, process.env.REACT_APP_SAVE_EMPLOYEE_INCREMENT_APPROVAL_CTC, formData);

    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to Save Employee Increment Approval CTC!");
    }

    Swal.fire({ icon: response?.status, title: response?.status, text: response.message || "Employee Increment Approval CTC submitted successfully!", });
    yield put({ type: types.SAVE_EMPLOYEE_INCREMENT_APPROVAL_CTC_SUCCESS, payload: response });
  } catch (error) {
    console.error("Saga API Error:", error);
    Swal.fire({ icon: "error", title: "API Error", text: error.message || "An error occurred while saving the deduction", });
    yield put({ type: types.SAVE_EMPLOYEE_INCREMENT_APPROVAL_CTC_FAILURE, payload: error.message });
  }
}

function* fetchEmployeeIncrementReportSaga({ payload }) {
  try {
    const response = yield call(post, process.env.REACT_APP_FETCH_EMPLOYEE_INCREMENT_REPORT, payload);
    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to retrieve Employee Increment Report!");
    }
    yield put({ type: types.FETCH_EMPLOYEE_INCREMENT_REPORT_SUCCESS, payload: response.data });
  } catch (error) {
    console.error("Saga API Error:", error);
    yield put({ type: types.FETCH_EMPLOYEE_INCREMENT_REPORT_FAILURE, payload: error.message });
  }
}

function* fetchEmployeeloannolistSaga({ payload }) {
  try {
    const response = yield call(post, process.env.REACT_APP_GET_EMPLOYEES_LOANNUMBER_LIST, payload);
    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to retrieve Employee Increment Report!");
    }
    yield put({ type: types.FETCH_EMPLOYEE_LOAN_NO_PRECLOSE_SUCCESS, payload: response.data });
  } catch (error) {
    console.error("Saga API Error:", error);
    yield put({ type: types.FETCH_EMPLOYEE_LOAN_NO_PRECLOSE_FAILURE, payload: error.message });
  }
}

function* fetchEmployeepreclosetSaga({ payload }) {
  try {
    const response = yield call(post, process.env.REACT_APP_GET_EMPLOYEES_PRECLOSE, payload);
    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to retrieve Employee Increment Report!");
    }
    yield put({ type: types.FETCH_EMPLOYEE_PRECLOSE_SUCCESS, payload: response.data });
  } catch (error) {
    console.error("Saga API Error:", error);
    yield put({ type: types.FETCH_EMPLOYEE_PRECLOSE_FAILURE, payload: error.message });
  }
}

function* saveEmployeepreclosetSaga({ payload }) {
  try {
    const { formData } = payload;
    const response = yield call(post, process.env.REACT_APP_SAVE_EMPLOYEES_PRECLOSE, formData);

    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to Save Employee Increment Approval CTC!");
    }

    Swal.fire({ icon: response?.status, title: response?.status, text: response.message || "Employee Increment Approval CTC submitted successfully!", });
    yield put({ type: types.SAVE_LOAN_PRECLOSE_SUCCESS, payload: response });
  } catch (error) {
    console.error("Saga API Error:", error);
    Swal.fire({ icon: "error", title: "API Error", text: error.message || "An error occurred while saving the deduction", });
    yield put({ type: types.SAVE_LOAN_PRECLOSE_FAILURE, payload: error.message });
  }
}

function* saveEmployeeloanfreezeSaga({ payload }) {
  try {
    const { formData } = payload;
    const response = yield call(post, process.env.REACT_APP_SAVE_EMPLOYEES_LOAN_FREEZE, formData);

    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to Save Employee Increment Approval CTC!");
    }

    Swal.fire({ icon: response?.status, title: response?.status, text: response.message || "Employee Increment Approval CTC submitted successfully!", });
    yield put({ type: types.SAVE_EMPLOYEE_LOAN_FREEZE_SUCCESS, payload: response });
  } catch (error) {
    console.error("Saga API Error:", error);
    Swal.fire({ icon: "error", title: "API Error", text: error.message || "An error occurred while saving the deduction", });
    yield put({ type: types.SAVE_EMPLOYEE_LOAN_FREEZE_FAILURE, payload: error.message });
  }
}

function* fetchEmployeefreezeSaga({ payload }) {
  try {
    const response = yield call(post, process.env.REACT_APP_GET_EMPLOYEES_LOAN_FREEZE, payload);
    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to retrieve Employee Increment Report!");
    }
    yield put({ type: types.FETCH_EMPLOYEE_LOAN_FREEZE_SUCCESS, payload: response.data });
  } catch (error) {
    console.error("Saga API Error:", error);
    yield put({ type: types.FETCH_EMPLOYEE_LOAN_FREEZE_FAILURE, payload: error.message });
  }
}

function* fetchEmployeeloanapprovalSaga({ payload }) {
  try {
    const response = yield call(post, process.env.REACT_APP_GET_LOAN_APPROVALS, payload);
    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to retrieve Employee Increment Report!");
    }
    yield put({ type: types.FETCH_EMPLOYEE_LOAN_APPOVAL_SUCCESS, payload: response.data });
  } catch (error) {
    console.error("Saga API Error:", error);
    yield put({ type: types.FETCH_EMPLOYEE_LOAN_APPOVAL_FAILURE, payload: error.message });
  }
}

function* saveEmployeeloanapprovalsSaga({ payload }) {
  try {
    const { formData } = payload;
    const response = yield call(post, process.env.REACT_APP_SAVE_LOAN_APPROVALS, formData);

    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to Save Employee Increment Approval CTC!");
    }

    Swal.fire({ icon: response?.status, title: response?.status, text: response.message || "Employee Increment Approval CTC submitted successfully!", });
    yield put({ type: types.SAVE_EMPLOYEE_LOAN_APPOVALS_SUCCESS, payload: response });
  } catch (error) {
    console.error("Saga API Error:", error);
    Swal.fire({ icon: "error", title: "API Error", text: error.message || "An error occurred while saving the deduction", });
    yield put({ type: types.SAVE_EMPLOYEE_LOAN_APPOVALS_FAILURE, payload: error.message });
  }
}

function* fetchsalaryscalSaga({ payload }) {
  try {
    const response = yield call(post, process.env.REACT_APP_GET_SALARY_SCALE, payload);
    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to retrieve Employee Increment Report!");
    }
    yield put({ type: types.FETCH_SALARY_GEN_SCALE_SUCCESS, payload: response.data });
  } catch (error) {
    console.error("Saga API Error:", error);
    yield put({ type: types.FETCH_SALARY_GEN_SCALE_FAILURE, payload: error.message });
  }
}

function* saveEmployeesalaryGenerationsSaga({ payload }) {
  try {
    const response = yield call(post, process.env.REACT_APP_SAVE_SALARY_GENERATION, payload);
    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to retrieve Employee Increment Report!");
    }
    yield put({ type: types.SAVE_SALARY_GENERATION_SUCCESS, payload: response.data });
  } catch (error) {
    console.error("Saga API Error:", error);
    yield put({ type: types.SAVE_SALARY_GENERATION_FAILURE, payload: error.message });
  }
}

function* savesalaryGenerationleaveapprovalsSaga({ payload }) {
  try {
    const { formData } = payload;
    const response = yield call(post, process.env.REACT_APP_SAVE_LEAVE_APPROVALS, formData);

    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to Save Employee Increment Approval CTC!");
    }

    Swal.fire({ icon: response?.status, title: response?.status, text: response.message || "Employee Increment Approval CTC submitted successfully!", });
    yield put({ type: types.SAVE_SALARY_GENERATION_LEAVE_APPROVALS_SUCCESS, payload: response });
  } catch (error) {
    console.error("Saga API Error:", error);
    Swal.fire({ icon: "error", title: "API Error", text: error.message || "An error occurred while saving the deduction", });
    yield put({ type: types.SAVE_SALARY_GENERATION_LEAVE_APPROVALS_FAILURE, payload: error.message });
  }
}

function* savesalaryGenerateaga({ payload }) {
  try {
    const { formData } = payload;
    const response = yield call(post, process.env.REACT_APP_SAVE_SALARY_GENERATE, formData);

    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to Save Employee Increment Approval CTC!");
    }

    showToast({ icon: response?.status, title: response?.status, text: response.message || "Employee Salary Generated Successfully", });
    yield put({ type: types.SAVE_SALARY_GENERATE_SUCCESS, payload: response });
  } catch (error) {
    console.error("Saga API Error:", error);
    showToast({ icon: "error", title: "API Error", text: error.message || "An error occurred while saving the deduction", });
    yield put({ type: types.SAVE_SALARY_GENERATE_FAILURE, payload: error.message });
  }
}

function* fetchsalarygenlogs({ payload: { unit_id } }) {
  try {
    const formData = new FormData();
    formData.append("unit_id", unit_id);
    const response = yield call(post, process.env.REACT_APP_GET_EMPLOYEE_SALARY_GENERATE_LOGS, formData);
    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to retrieve Employee Increment Report!");
    }
    yield put({ type: types.FETCH_SALARY_LOGS_SUCCESS, payload: response.data });
  } catch (error) {
    console.error("Saga API Error:", error);
    yield put({ type: types.FETCH_SALARY_LOGS_FAILURE, payload: error.message });
  }
}

// Watcher Saga
function* payrollSalaryEmployeeSalaryDefinitionSaga() {
  yield takeEvery(types.FETCH_EMPLOYEE_SALARY_DEFINITION, fetchEmployeeSalaryDefinitionSaga);
  yield takeEvery(types.FETCH_EMPLOYEE_SALARY_DEFINITION_CLEAR, fetchEmployeeSalaryDefinitionClearSaga);
  yield takeEvery(types.SAVE_EMPLOYEE_SALARY_DEFINITION, saveEmployeeSalaryDefinitionSaga);
  yield takeEvery(types.FETCH_EMPLOYEE_SALARY_INCREMENT, fetchEmployeeSalaryIncrementSaga);
  yield takeEvery(types.FETCH_FINANCIAL_INCREMENT_TYPES, fetchfinancialtypesSaga);
  yield takeEvery(types.FETCH_LOAN_TYPES, fetchloantypesSaga);
  yield takeEvery(types.FETCH_LOAN_LOANNUMBER, fetchloannumberSaga);
  yield takeEvery(types.FETCH_LOAN_MONTHLY_INSTALLMENTS, fetchloaninstallmentsSaga);
  yield takeEvery(types.SAVE_LOAN_MONTHLY_INSTALLMENTS, saveloaninstallmentsSaga);
  yield takeEvery(types.FETCH_EMPLOYEE_LOAN_LISTS, fetchEmployeeLoanlistsSaga);
  yield takeEvery(types.FETCH_EMPLOYEE_LOAN_INSTALLMENTS, fetchEmployeeLoaninstallmentsSaga);
  yield takeEvery(types.SAVE_EMPLOYEE_SALARY_INCREMENT_CTC, saveEmployeeSalaryIncrementCTCSaga);
  yield takeEvery(types.FETCH_EMPLOYEE_SALARY_INCREMENT_SAVED_CTC, fetchEmployeeSalaryIncrementsavedctcSaga);
  yield takeEvery(types.FETCH_EMPLOYEE_INCREMENT_APPROVAL_CTC, fetchEmployeeIncrementapprovalctcSaga);
  yield takeEvery(types.SAVE_EMPLOYEE_INCREMENT_APPROVAL_CTC, saveEmployeeIncrementApprovalCTCSaga);
  yield takeEvery(types.FETCH_EMPLOYEE_INCREMENT_REPORT, fetchEmployeeIncrementReportSaga);
  yield takeEvery(types.FETCH_EMPLOYEE_LOAN_NO_PRECLOSE, fetchEmployeeloannolistSaga);
  yield takeEvery(types.FETCH_EMPLOYEE_PRECLOSE, fetchEmployeepreclosetSaga);
  yield takeEvery(types.SAVE_LOAN_PRECLOSE, saveEmployeepreclosetSaga);
  yield takeEvery(types.SAVE_EMPLOYEE_LOAN_FREEZE, saveEmployeeloanfreezeSaga);
  yield takeEvery(types.FETCH_EMPLOYEE_LOAN_FREEZE, fetchEmployeefreezeSaga);
  yield takeEvery(types.FETCH_EMPLOYEE_LOAN_APPOVAL, fetchEmployeeloanapprovalSaga);
  yield takeEvery(types.SAVE_EMPLOYEE_LOAN_APPOVALS, saveEmployeeloanapprovalsSaga);
  yield takeEvery(types.FETCH_SALARY_GEN_SCALE, fetchsalaryscalSaga);
  yield takeEvery(types.SAVE_SALARY_GENERATION, saveEmployeesalaryGenerationsSaga);
  yield takeEvery(types.SAVE_SALARY_GENERATION_LEAVE_APPROVALS, savesalaryGenerationleaveapprovalsSaga);
  yield takeEvery(types.SAVE_SALARY_GENERATE, savesalaryGenerateaga);
  yield takeEvery(types.FETCH_SALARY_LOGS, fetchsalarygenlogs);
}

export default payrollSalaryEmployeeSalaryDefinitionSaga;
